import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JackingActivityEditCancelPage } from './jacking-activity-edit-cancel';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../shared/shared.module';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    JackingActivityEditCancelPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(JackingActivityEditCancelPage),
    TextMaskModule,
    SharedModule,
  ],
})
export class JackingActivityEditCancelPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-edit-cancel/jacking-activity-edit-cancel.module.ts